module.exports = __webpack_public_path__ + "static/media/3DEABF52-56E0-46FD-98D9-FEDCD22E468A.0d4d1ddd.PNG";